export default "<button (click) = \"deleteMethod()\" class=\"pi pi-minus-circle font-size-18 delete-btn\" > </button>\r\n\r\n";